import React from "react";
import { siteData } from "../mock";

const WhyJoin = () => {
  const { whyJoin } = siteData;
  return (
    <section id="why-join" className="py-24 lg:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          <div>
            <p className="text-[#4a90c2] font-semibold uppercase tracking-[0.18em] text-sm ht-body">
              {whyJoin.eyebrow}
            </p>
            <h2 className="mt-4 ht-display text-3xl sm:text-4xl lg:text-5xl text-[#2c3e50] leading-[1.1]">
              {whyJoin.title}
            </h2>
            <p className="mt-6 ht-body text-[#5a6b7d] text-base sm:text-lg leading-relaxed">
              {whyJoin.body}
            </p>
            <p className="mt-5 ht-body text-[#2c3e50] text-base sm:text-lg">
              {whyJoin.subBody}
            </p>
            <ul className="mt-5 space-y-3">
              {whyJoin.reasons.map((r) => (
                <li
                  key={r}
                  className="ht-bullet ht-body text-[#2c3e50]"
                >
                  {r}
                </li>
              ))}
            </ul>
          </div>

          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden shadow-xl ring-1 ring-[#e2eaf2]">
              <img
                src={whyJoin.image}
                alt="A welcoming community member"
                className="w-full h-[480px] object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#3d4e62]/25 via-transparent to-transparent" />
            </div>
            <div className="absolute -inset-4 -z-10 rounded-3xl bg-gradient-to-br from-[#eaf4fb] to-[#dfeefa] blur-2xl opacity-70" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyJoin;
